<template>
    <div class="chat" v-if="isOpen">
        <div class="chat-agent">
            <div
                class="chat-header d-flex justify-content-between align-items-center"
            >
                TEI Chat Assistant
                <div
                    class="chat-close-button d-flex align-items-center justify-content-center rounded-circle"
                    @click="handleCloseButton"
                >
                    <font-awesome-icon size="md" icon="fa-solid fa-xmark" />
                </div>
            </div>
            <div class="chat-agent-messages">
                <p class="small p-2 rounded info-text">
                    Chats may be monitored, recorded and reviewed by Tenny
                    Enterprises to respond to your requests and for quality,
                    training, and improvement purposes. By continuing to chat,
                    you agree to the TEI Privacy Policy and Terms of Use.
                </p>
                <!-- <div v-if="!startChat" class="msg-wrapper">
                    <template v-if="chatRoomDetails?.messages?.length > 0">
						<div
							v-for="(msg, index) in chatRoomDetails.messages"
							:key="index"
							:class="['chat-bubble', msg.is_sender ? 'sender' : 'receiver']"
						>
						<span v-if="!msg.is_hidden">
							{{ msg.message }}
						</span>
						<div class="message-meta d-flex justify-content-between align-items-center">
							<small class="timestamp mt-2">{{ formatDateTime(message.createdAt) }}</small>
						</div>
						</div>
                    </template>
                </div> -->
                <div v-if="!startChat" class="msg-wrapper">
                    <template v-if="chatRoomDetails?.messages?.length > 0">
                        <div
                            v-for="(msg, index) in chatRoomDetails.messages"
                            :key="index"
                            :class="[
                                'chat-bubble-wrapper',
                                msg.is_sender ? 'from-sender' : 'from-receiver',
                            ]"
                        >
                            <div
                                v-if="!msg.is_hidden"
                                class="d-flex flex-column gap-2 chat-content-container"
                            >
                                <div class="chat-bubble">
                                    <p class="chat-text">{{ msg.message }}</p>
                                </div>
                                <small
                                    :class="[
                                        'timestamp',
                                        msg.is_sender
                                            ? 'from-sender'
                                            : 'from-receiver',
                                    ]"
                                    >{{ formatDateTime(msg.createdAt) }}</small
                                >
                            </div>
                        </div>
                    </template>
                </div>
                <div ref="chatBottom"></div>
            </div>
            <div class="chat-input position-relative" v-if="!startChat">
                <input
                    class="form-control input-field"
                    v-model="newChatMessage.message"
                    type="text"
                    placeholder="Type a message..."
                    @keyup.enter="sendMessage"
                />
                <button
                    class="btn rounded-circle position-absolute d-flex align-items-center justify-content-center send-message-button"
                    @click="sendMessage"
                >
                    <font-awesome-icon
                        size="md"
                        icon="fa-solid fa-paper-plane"
                    />
                </button>
            </div>
            <div class="px-3 py-2 border-top" v-else>
                <button
                    class="chat-with-agent-button d-flex align-items-center gap-2"
                    @click="startChatting"
                >
                    <font-awesome-icon icon="comment-dots" />
                    Start the chat
                </button>
            </div>
        </div>
    </div>
</template>

<script src="./ChatAgentScript.vue" />
